import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
} from "react-router-dom";
// import UnitDetailMaster from "./storeDirectory/UnitDetailMaster";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import ListingForm from "./leaseList/ListingForm";
import TopHeader from "../layout/TopHeader";
import LeaseDetails from "./LeaseDetails";
import LeaseDetailsContainer from "./LeaseDetailsContainer";
export default function ViewLease() {
  let match = useRouteMatch();

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        {/* <h2>Masters</h2> */}

        {/* The Topics page has its own <Switch> with more routes
              that build on the /topics URL path. You can think of the
              2nd <Route> here as an "index" page for all topics, or
              the page that is shown when no topic is selected */}
        <Switch>
          <Route path={`${match.path}/lease-details/:id`}>
            <LeaseDetailsContainer />
          </Route>
          <Route path={`${match.path}/:status/:brand/:state`}>
            <ListingForm />
          </Route>
          <Route path={`${match.path}/:status/:brand/`}>
            <ListingForm />
          </Route>
          <Route path={`${match.path}/:status//:state`}>
            <ListingForm />
          </Route>
          <Route path={`${match.path}/:status//`}>
            <ListingForm />
          </Route>

          <Route path={`${match.path}`}>
            <ListingForm />
          </Route>
        </Switch>
      </div>
    </div>
  );
}
